// @ts-strict-ignore
import React from 'react';

import { reportBudget } from 'loot-core/client/queries';
import * as monthUtils from 'loot-core/shared/months';
import { rangeInclusive } from 'loot-core/shared/months';

export function SpendingByCategorySpreadsheet(categories, start, end) {
  return async (spreadsheet, setData) => {
    const categoriesData = [];

    if (start && end) {
      for (const category of categories) {
        let actualAmount = 0;
        let budgetedAmount = 0;
        for (const month of rangeInclusive(start, end)) {
          const sheetName = monthUtils.sheetForMonth(month);
          const monthlyActualBudget = await spreadsheet.get(
            sheetName,
            reportBudget.catSumAmount(category.id),
          );
          const monthlyBudgetedBudget = await spreadsheet.get(
            sheetName,
            reportBudget.catBudgeted(category.id),
          );

          actualAmount += monthlyActualBudget.value;
          budgetedAmount += monthlyBudgetedBudget.value;
        }

        if (actualAmount || budgetedAmount) {
          categoriesData.push({
            id: category.id,
            name: category.name,
            actualAmount,
            budgetedAmount,
          });
        }
      }
    }

    return setData({
      graphData: categoriesData.sort((a, b) => a.totalAmount - b.totalAmount),
    });
  };
}
